// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".dropdown__activator[data-v-e4a1b478]{height:48px}.v-menu__content .menu__container[data-v-e4a1b478]{line-height:1.17;letter-spacing:.25px!important;border-radius:8px}.v-menu__content .menu__item[data-v-e4a1b478]{cursor:pointer}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
